<template>
  <div :class="`p-4 site-list ${viewType}`">
    <c-row class="mb-3">
      <c-col class="view-as">
        View as
        <a href="#" @click="setView('list')">List</a>
        |
        <a href="#" @click="setView('grid')">Grid</a>
      </c-col>
      <c-col>
        <!--        <CButton-->
        <!--            class="update-all-plugins float-right"-->
        <!--            color="plugin-update"-->
        <!--            size="sm"-->
        <!--            @click="() => $store.commit('addSuccessMessage', {-->
        <!--                    header: 'Site update error', message: 'Update all'-->
        <!--                  })"-->
        <!--        >-->
        <!--          Update&nbsp;all&nbsp;themes-->
        <!--        </CButton>-->
      </c-col>
    </c-row>

    <template v-if="viewType === 'list'">
      <c-row
        v-for="(site, index) in sites"
        v-show="(showOnlyRequireUpdates && site.updatesRequired > 0) || !showOnlyRequireUpdates"
        :key="index"
        class="py-2 site-row"
        :class="{ 'is-loading': site.isLoading, 'refresh-failed': site.success === false }"
      >
        <c-col class="site-image" sm="1">
          <img v-if="getScreenShot(site)" :src="getScreenShot(site)" class="screenshot" />
          <div v-else class="no-image" />
        </c-col>
        <c-col class="site-name" sm="5">
          <router-link
            :to="{ name: 'detailsSite', params: { siteId: site._id } }"
            v-html="site.name || site.siteAddress"
          ></router-link>
          <p class="mb-0 site-link">{{ site.siteAddress }}</p>
        </c-col>
        <c-col class="site-notes" sm="3">
          Version:
          <span class="pl-3">{{ site.theme.version || 'Not found' }}</span>
        </c-col>
        <c-col class="site-notes" sm="1">
          <span
            v-if="site.notes"
            v-c-popover="{
              header: 'Note',
              content: site.notes,
              placement: 'top-start',
              size: 'lg',
            }"
            class="mt-2 d-block"
          >
            <c-icon :content="freeSet.cilList" />
            Note
          </span>
        </c-col>
        <!--        <CCol class="site-plugins" sm="2">-->
        <!--          <span class="mt-2 d-block" v-if="site.scrapeDone">-->
        <!--            <CIcon :content="freeSet.cilPuzzle"/> Plugins <pill :value="site.updatesRequired"/>-->
        <!--          </span>-->
        <!--        </CCol>-->
        <c-col class="site-actions" sm="2">
          <c-button v-if="site.theme.updateFound" class="float-right" color="plugin-update" size="sm">
            Update to {{ site.theme.updateInfo.new_version }}
          </c-button>
        </c-col>
      </c-row>
    </template>

    <template v-else>
      <c-row class="py-2 site-row">
        <c-col
          v-for="(site, index) in sites"
          v-show="(showOnlyRequireUpdates && site.updatesRequired > 0) || !showOnlyRequireUpdates"
          :key="index"
          class="site-image mb-3"
          sm="12"
          md="3"
          :class="{ 'is-loading': site.isLoading, 'refresh-failed': site.success === false }"
        >
          <div class="align-bottom site-name-wrapper d-flex align-bottom">
            <router-link
              class="site-name"
              :to="{ name: 'detailsSite', params: { siteId: site._id } }"
              v-html="site.name || site.siteAddress"
            />
          </div>
          <router-link :to="{ name: 'detailsSite', params: { siteId: site._id } }">
            <img v-if="getScreenShot(site)" :src="getScreenShot(site)" class="screenshot" />
            <div v-else class="no-image"><p>No image</p></div>
          </router-link>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { freeSet } from '@coreui/icons';
import _ from 'lodash';
import io from 'socket.io-client';
import { buildEndpoint } from '../../libs/buildEndPoint';
import { parseScrapeData } from '../../libs/plugin/parseScrapeData';
import Pill from './Pill';

const socket = io(buildEndpoint(''));

/**
 * Update site data for display
 * @param site
 * @param updatedData
 */
function updateSiteData(site, updatedData) {
  site.pluginCount = updatedData.pluginCount;
  site.scrapeData = updatedData.scrapeData;
  site.updatedAt = updatedData.updatedAt;
  site.wpVersion = updatedData.wpVersion;
  site.updatesRequired = updatedData.updatesRequired;
  // Update site name if found - it can change between scrapes
  console.log(updatedData);
  if (updatedData.siteInfo.name !== undefined) {
    site.name = updatedData.siteInfo.name;
  }
}

export default {
  name: 'SiteListForPlugin',
  components: {
    Pill,
  },
  props: {
    sites: Array,
    readOnly: Boolean,
    hideHeader: Boolean,
    noBox: Boolean,
    showOnlyRequireUpdates: Boolean,
  },
  data() {
    return {
      error: null,
      filterSites: null,
      freeSet,
      viewType: 'list',
    };
  },
  created() {
    const _this = this;
    socket.emit('room', Vue.localStorage.get('mp-sid'));
    socket.on('siteRefreshNotification', (data) => {
      const site = _.find(_this.sites, { _id: data.siteId });
      switch (data.action) {
        case 'site-refresh-started':
          site.isLoading = true;
          break;
        case 'site-refresh-finished':
          site.isLoading = false;
          site.pluginCount = data.data.pluginCount;
          site.wpVersion = data.data.wpVersion;
          site.updatesRequired = data.data.updatesRequired;
          site.updatedAt = data.data.updatedAt;
          site.success = data.data.success;
          break;
        default:
          break;
      }
    });
  },
  methods: {
    setView(type) {
      this.viewType = type;
    },
    getScreenShot(site) {
      return _.get(site, 'screenshots.desktop.thumb.url', '');
    },
    clearSearch() {
      this.filterSites = null;
    },
    findSites(site) {
      const searchStr = site.name.toLowerCase() + site.siteAddress.toLowerCase();
      return searchStr.indexOf(this.filterSites) !== -1;
    },
    refreshSite(site) {
      site.isLoading = true;
      this.error = null;
      this.$http({
        url: buildEndpoint(`site/scrape/${site._id}`),
      })
        .then((response) => {
          site.isLoading = false;
          if (response.data.success) {
            const updatedData = parseScrapeData(response.data.data);
            updateSiteData(site, updatedData);
            site.scrapeDone = true;
          } else {
            this.error = response.data.message + (response.data.error ? `: ${response.data.error}` : '');
          }
        })
        .catch((error) => {
          site.isLoading = false;
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
.view-as {
  font-size: 14px;

  a {
    font-weight: bold;
    font-size: inherit;
  }
}

.c-dark-theme {
  .site-list {
    /*background-color: #353739;*/
    background-color: #23242d;

    &.list {
      .site-row {
        border-bottom: 1px solid #333;
        /*border-bottom: 1px solid #1f1f1f;*/
      }
    }

    &.grid {
      .site-name {
        color: white;
      }
    }
  }
}

.site-list {
  font-size: 12px;

  &.list {
    .site-row {
      border-bottom: 1px solid #eee;
    }

    .site-name {
      font-weight: bold;

      .site-link {
        font-weight: normal;
      }
    }

    .site-notes {
      & > span {
        cursor: pointer;
      }
    }

    .screenshot {
      width: 50px;
    }

    .no-image {
      width: 50px;
      height: 31px;
      background: rgba(0, 209, 178, 0.3);
    }
  }

  &.grid {
    .screenshot {
      width: 90%;

      &:hover {
        outline: 1px solid #00d1b2;
      }
    }

    .no-image {
      /*width: 188px;*/
      /*height: 118px;*/
      width: 90%;
      height: 70%;
      background: rgba(0, 209, 178, 0.3);

      p {
        display: inline-block;
        width: 100%;
        text-align: center;
        margin-top: 50px;
      }
    }

    .site-name-wrapper {
      margin-bottom: 10px;
      min-height: 35px;
      height: 35px;
      position: relative;
    }

    .site-name {
      font-weight: bold;
      font-size: 12px;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
